module.exports = __webpack_public_path__ + "static/media/blue_computer.ef235bfa.svg";